import { View } from "@react-pdf/renderer";
import PdfSignatureImage from "../../components/PdfSignatureImage";
import PdfLabel from "../../components/typography/PdfLabel";
import PdfValue from "../../components/typography/PdfValue";
import { formatDate } from "../../../../../_src_shared/utils/functions/formatDate";

const PdfBuilderSectionSignature = ({
  submissionDate,
  fullName,
  label,
  signature,
}) => {
  console.log("submissionDate", submissionDate);
  return (
    <View style={{ marginTop: 20, marginBottom: 10 }}>
      {label && <PdfLabel>{label}</PdfLabel>}
      <PdfSignatureImage src={signature} />
      {fullName && <PdfValue>{fullName}</PdfValue>}
      {submissionDate && <PdfValue>{formatDate(submissionDate)}</PdfValue>}
    </View>
  );
};

export default PdfBuilderSectionSignature;
